import React, { useEffect, useState } from "react";
import { disableDarkMode, enableDarkMode } from "../../utils/darkMode"

function DarkMode({ pathRoute }) {
    const [darkModeStatus, setDarkModeStatus] = useState(() =>
        localStorage.getItem("darkmode") || "off"
    );


    const activeDarkMode = () => {
        if (darkModeStatus === "on") {
            setDarkModeStatus("off");
            disableDarkMode()
        } else {
            setDarkModeStatus("on");
            enableDarkMode()
        }
    };

    useEffect(() => {
        if (pathRoute === "/home") {
            const savedDarkModeStatus = localStorage.getItem("darkmode");
            if (savedDarkModeStatus === "on") {
                setDarkModeStatus("on");
                document.body.classList.add("dark-mode");
            } else {
                setDarkModeStatus("off");
                document.body.classList.remove("dark-mode");
            }
        } else {
            setDarkModeStatus("off");
            document.body.classList.remove("dark-mode");
        }
    }, [pathRoute]);

    return (
        <a
            style={{ marginTop: 2, cursor: "pointer" }}
            className="nav-link dark-mode-button"
            onClick={() => pathRoute === "/home" && activeDarkMode()} 
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === "Enter" && pathRoute === "/home" && activeDarkMode()} 
        >
            <i className="fa fa-moon-o" aria-hidden="true" />{" "}
            {darkModeStatus === "on" && pathRoute === "/home" ? "Modo noturno" : <span className="d-inline-block d-sm-none">Mudar para modo noturno</span>}
        </a>
    );
}

export default DarkMode;